<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <bolt_general_tab :location="location"></bolt_general_tab>
        </template>


        <template v-slot:bolt_work_hour="{ location, name }">
            <bolt_work_hour :location="location"></bolt_work_hour>
        </template>

        <template v-slot:bolt_labels="{ location, name }">
            <bolt_labels :location="location"></bolt_labels>
        </template>


    </base_location_modal>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import bolt_general_tab from "./tabs/bolt_general_tab";
import bolt_work_hour from "./tabs/bolt_work_hour";
import bolt_labels from "./tabs/bolt_labels";


export default {
    name: "bolt_location_modal",
    components : {
        base_location_modal,
        bolt_general_tab,
        bolt_work_hour,
        bolt_labels
    },

    created() {

    },

    data () {
        return {
            tabs_add : [
                {
                    index : "bolt_work_hour",
                    title : this.__t('BOLT_WORK_HOUR'),
                },
                {
                    index : "bolt_labels",
                    title : this.__t('BOLT_LABELS'),
                },
            ]
        }
    },


}
</script>

<style scoped>

</style>
